export default __webpack_public_path__ + "static/media/projectBg.dd7acd63.png";